// BASIC STARTER REQUIREMENTS
window.jQuery = window.$ = require('jquery');
require('./vendor/skip-link-focus-fix.js')
require('jquery.cookie')
var LazyLoad = require('vanilla-lazyload');

// ADDITIONAL 3RD PARTY REQUIREMENTS
// var slick 			= require('slick-carousel');
// var _ 				= require('underscore');
// var moment 			= require('moment');
// var foundation 		= require('foundation-sites'); // Requires: npm install foundation-sites

require('./gallery.js');
require('./collection.js');

// Get Viewport Dimensions
function updateViewportDimensions() {
    var w=window,d=document,e=d.documentElement,g=d.getElementsByTagName('body')[0],x=w.innerWidth||e.clientWidth||g.clientWidth,y=w.innerHeight||e.clientHeight||g.clientHeight;
    return { width:x,height:y };
}

// setting the viewport width
var viewport = updateViewportDimensions();

// David Walsh Debounce
function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    }
}


// Cornerstone Media Namespace
var CM = CM || {};

// utilities
CM.query = function(selector) {
    return document.querySelector(selector);
};

CM.isHome = !!document.getElementsByClassName('home').length;
CM.isFlexible = !!document.getElementsByClassName('page-template-page-flexible').length;
CM.hasForm = !!document.getElementsByClassName('gform_wrapper').length;



// Set up namespace
var CMStarter = CMStarter || {};

(function(ns, $win, $, undefined) {
    var $htmlBody = $('html, body');

    // http://jquery.eisbehr.de/lazy/
    // usage <img class="lazy" data-src="/some-path" alt=""> for img
    // usage <div class="lazy" data-src="/some-path" alt=""> for background image
    // function initLazyLoad() {
    //     $('.lazy').lazy({
    //         effect: "fadeIn",
    //         effectTime: 500,
    //         threshold: 500
    //     });
    // }

    function toggleNavMenu() {
        var $menu = $('.main-navigation');
        $('.mobile-toggle-header-nav').on('click',function(){
            $('.mobile-toggle-header-nav').toggleClass('active');
            $menu.slideToggle();
        });
    }

    function subMenus() {
        var $navItem = $('.menu-item-has-children');

        $navItem.hover(
            function(){
                var $this = $(this);
                var $subMenu = $this.find('.sub-menu');
                $subMenu.addClass('show-menu');
            },
            function(){
                var $this = $(this);
                var $subMenu = $this.find('.sub-menu');
                $subMenu.removeClass('show-menu');
            }
        );
    }

    function smoothScroll() {
        var $links = $('.smooth-scroll');

        $links.click(function(e){
            e.preventDefault();
            var $this = $(this);
            var $target = $($this.attr('href'));
            $htmlBody.animate({scrollTop: $target.offset().top}, '500', 'swing');
        });
    }


    function contentAccordion() {
        $('.content-accordion').on('click', '.content-accordion--btn', function() {
            var $btn = $(this);
            var $container = $btn.closest('.content-accordion');
            var $content = $container.find('.content-accordion--hidden');
            $content.slideToggle(function(){
                $content.is(':visible') ? $btn.text('See Less') : $btn.text('See More');;
            });
        });
    }





    // ----
    // public methods and variables
    // ----
    ns.init = function() {
        subMenus();
        toggleNavMenu();
        smoothScroll();
        // initLazyLoad();
        contentAccordion();
    };

    ns.windowLoadInit = function() {
    };



}(CMStarter = CMStarter || {}, jQuery(window), jQuery));







jQuery(document).ready(function($) {

  CMStarter.init();

  $('img').not('img.no-lazy, .juicer-feed img').each(function(){
    var $img = $(this)
    if($(this).closest('#wpadminbar').length > 0) {
        return
    }
    $img.attr('data-src', $img.attr('src'))
    $img.removeAttr('src')
    var paddingBottom = 100
    var inlineStyle = ''
    if($img.hasClass('fixed-aspect-ratio')) {
        // CSS will handle the padding-bottom via aspect ratio utility classes
        inlineStyle = ''
    } else {
        if($img.attr('height') && $img.attr('width'))  {
            paddingBottom = $img.attr('height') / $img.attr('width') * 100
        }
        inlineStyle = 'style="padding-bottom: '+paddingBottom+'%"'
    }
    $img.wrap('<span class="lazy-load-wrap" '+inlineStyle+'></span>')
    $img.after('<span class="placeholder"></span>')
    if($img.attr('width') && !$img.hasClass('no-max')){
        $img.closest('.lazy-load-wrap').wrap('<span class="lazy-load-wrap-inliner '+$img.attr('class')+'" style="max-width: '+$img.attr('width')+'px;"></span>')
    }
  })

  setTimeout(function () {
    var ejLazyLoad = new LazyLoad();
  }, 50)

  $('.faq-question').on('click', function(e) {
    e.preventDefault();
    var faq = $(this).closest('li');
    if (faq.hasClass('active')) {
        faq.removeClass('active')
        faq.find('.faq-answer').slideUp();
    } else {
        faq.addClass('active')
        faq.find('.faq-answer').slideDown();
    }
  });

    if ($('.site-alert').length > 0) {
        var siteALertText = $('.site-alert .site-alert--text').text()
        var siteAlertClosed = $.cookie('ej-site-alert') ||  null
        if (siteAlertClosed && siteALertText == siteAlertClosed) {
            $('.site-alert').hide();
            // setTimeout(function() {
            //     $('.site-alert').slideDown()
            // }, 3000)
        }
        $('.site-alert--close').on('click', function() {
            $('.site-alert').slideUp()
            $.cookie('ej-site-alert', siteALertText, { expires: 1, path: '/' });
        })
    }
    
});

// jQuery(window).load(function() {
//     // CMStarter.windowLoadInit();
// });